// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__15ku4","index":"styles_index__vNKQl"};